import React, { useMemo, useState } from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { AppBar } from "@material-ui/core";
import Icon from "@material-ui/core/Icon";
import IconButton from "@material-ui/core/IconButton";
import useTemplateInstance from "../../../hooks/useTemplateInstance";
import { usePriceList } from "../../../../providers/PriceListProvider";
import { Trans, useTranslation } from "react-i18next";
import ProductPriceInfoPopup from "../../ProductPriceInfoPopup";
import { usePackageInstance } from "../../../../../Providers/PackageInstanceProvider";
import { getTemplateTranslation } from "../../../../../Providers/TemplateInstanceProvider";
import i18next from "i18next";
import { useShoppingCart } from "../../../../providers/ShoppingCartProvider";
import { formatCurrency } from "../../../../../utils";

const useStyles = makeStyles((theme) => ({
  appBarRoot: {
    backgroundColor: "white",
    color: "black",
  },
  toolbar: {
    display: "flex",
    alignItems: "center",
    minHeight: "56px",
    "& .material-icons": {
      color: theme.palette.primary.main,
    },
    "& button": {
      zIndex: 2,
    },
  },
  titleContainer: {
    flexGrow: 1,
    marginLeft: "-48px",
    position: "relative",
    top: "3px",
    "& h2": {
      fontSize: "15px",
      marginTop: 0,
      marginBottom: 0,
      lineHeight: 1,
      textAlign: "center",
      fontWeight: 500,
    },
    "& div": {
      fontSize: "12px",
      marginTop: 0,
      marginBottom: 0,
      fontWeight: "normal",
      textAlign: "center",
    },
  },
  priceCell: {
    textAlign: "right",
  },
  prices: {
    textDecoration: "underline",
  },
  priceContainer: {
    "& .original-price": {
      color: "#00000094",
      textDecoration: "line-through",
    },
  },
}));

export default ({ onCancel }) => {
  const classes = useStyles();
  let packageInstance = null;
  try {
    packageInstance = usePackageInstance();
  } catch (e) {}
  const [state] = useTemplateInstance();
  const { getPriceAsString, getPromotedPrice } = usePriceList();
  const { qualifyForPromotedPrice } = useShoppingCart();
  const [showPriceInfo, setShowPriceInfo] = useState(false);
  const product = state.product;
  const [t] = useTranslation();

  const getPriceString = () => {
    const promotedPrice = getPromotedPrice(product);
    if (qualifyForPromotedPrice && promotedPrice) {
      return (
        <>
          <span className="original-price">
            {formatCurrency(product.productprices[0].price)}
          </span>{" "}
          {formatCurrency(promotedPrice)}
        </>
      );
    }
    return getPriceAsString(product, state.template.categories);
  };

  const priceAsString = getPriceString();

  const [primaryText, secondaryText] = useMemo(() => {
    if (packageInstance) {
      return [
        getTemplateTranslation(state.template.name, i18next.language),
        packageInstance.name,
      ];
    } else {
      return [
        product.name,
        <div className={classes.priceContainer}>
          {priceAsString}{" "}
          {product.productprices.length > 1 && (
            <span>
              {" "}
              (
              <span className={classes.prices}>
                <Trans>Prices</Trans>
              </span>
              )
            </span>
          )}
        </div>,
      ];
    }
  }, [packageInstance, state]);
  console.log("The package instance", packageInstance);

  return (
    <React.Fragment>
      <AppBar
        classes={{ root: classes.appBarRoot }}
        position="static"
        onClick={() => setShowPriceInfo(true)}
      >
        <div className={classes.toolbar}>
          <IconButton
            onClick={onCancel}
            aria-label={
              packageInstance
                ? t("Back to package")
                : t("Back to template list")
            }
          >
            <Icon>arrow_back</Icon>
          </IconButton>
          <div className={classes.titleContainer}>
            <h2>{primaryText}</h2>
            <div>{secondaryText}</div>
          </div>
        </div>
      </AppBar>
      {!packageInstance && (
        <ProductPriceInfoPopup
          product={product}
          categories={state.template.categories}
          open={!!showPriceInfo}
          handleClose={() => setShowPriceInfo(false)}
        />
      )}
    </React.Fragment>
  );
};
